import React, { useState, useEffect, useCallback } from "react";
import {
  // FaUserMd,
  // FaHospital,
  // FaClipboardList,
  // FaStethoscope,
  // FaSpinner,
   FaUserCircle,
  FaClipboardList,
  FaExclamationTriangle,
  FaCheckCircle,
  FaSpinner,
} from "react-icons/fa";
import { Link } from 'react-router-dom';
import { useUser } from '../UserContext';

const TeacherHome = () => {
  const { user } = useUser();
  const [dashboardStats, setDashboardStats] = useState({
    pendingApproval: 0,
    approvedAssignments: 0,
    referredBack: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchPendingReports = useCallback(async () => {
    setLoading(true);
    try {
      const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost:5001').trim();
      const response = await fetch(`${apiUrl}/api/report-stats`);
      if (!response.ok) {
        throw new Error('Failed to fetch PDF reports');
      }
      const data = await response.json();
      const teacherReports = data.filter(report=>report.teacher_username && user && report.teacher_username.toLowerCase()=== user.username.toLowerCase());
      const pendingReports = teacherReports.filter(report => report.status === 'pending');
      const approvedReports = teacherReports.filter(report => report.status === 'approved');
      const rejectedReports = teacherReports.filter(report => report.status === 'rejected');
      setDashboardStats(prev => ({
        ...prev,
        pendingApproval: pendingReports.length,
        approvedAssignments: approvedReports.length,
        referredBack: rejectedReports.length
      }));
    } catch (err) {
      console.error('Error fetching reports:', err);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user && user.username) {
      fetchPendingReports();
    }
  }, [user, fetchPendingReports]);

  useEffect(() => {
    console.log(dashboardStats);
  }, [dashboardStats]);

  // return (
  //   <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-teal-50">
  //     <div className="w-[95%] mx-auto bg-white p-10 shadow-2xl backdrop-blur-lg border border-gray-200 rounded-2xl">
  //       {user && user.role === "teacher" ? (
  //         <div className="text-center">
  //           {/* Profile Section with Healthcare Theme */}
  //           <div className="flex flex-col items-center mb-10">
  //             <div className="bg-gradient-to-r from-blue-600 to-teal-500 text-white p-5 rounded-full mb-4 shadow-lg">
  //               <FaUserMd className="text-8xl drop-shadow-md" />
  //             </div>
  //             <div className="bg-gradient-to-r from-blue-600 to-teal-500 text-white px-12 py-5 rounded-xl shadow-lg">
  //               <h1 className="text-4xl font-bold tracking-wide">Welcome, Dr. {user.name || user.username}</h1>
  //               <p className="text-xl mt-2 font-light">Faculty Dashboard</p>
  //               <p className="text-md mt-1 font-light opacity-80">Empowering Medical Education</p>
  //             </div>
  //           </div>

  //           {/* Statistics Section with Medical Theme */}
  //           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
  //             <Link to="/teacher-dashboard/teacher-pending-report" className="stat-card bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 text-blue-900 p-8 rounded-xl shadow-lg">
  //               <FaClipboardList className="text-5xl mx-auto text-blue-600 mb-4" />
  //               <h3 className="text-xl font-semibold mb-2">Pending Approval</h3>
  //               {loading ? (
  //                 <div className="flex justify-center py-2">
  //                   <FaSpinner className="animate-spin text-2xl text-blue-600" />
  //                 </div>
  //               ) : (
  //                 <p className="text-4xl font-bold">{dashboardStats.pendingApproval}</p>
  //               )}
  //             </Link>

  //             <Link to="/teacher-dashboard/teacher-approved-report" className="stat-card bg-gradient-to-br from-green-50 to-teal-100 border border-green-200 text-green-900 p-8 rounded-xl shadow-lg">
  //               <FaStethoscope className="text-5xl mx-auto text-green-600 mb-4" />
  //               <h3 className="text-xl font-semibold mb-2">Approved Assignments</h3>
  //               {loading ? (
  //                 <div className="flex justify-center py-2">
  //                   <FaSpinner className="animate-spin text-2xl text-green-600" />
  //                 </div>
  //               ) : (
  //                 <p className="text-4xl font-bold">{dashboardStats.approvedAssignments}</p>
  //               )}
  //             </Link>

  //             <Link to="/teacher-dashboard/teacher-rejected-report" className="stat-card bg-gradient-to-br from-red-50 to-orange-100 border border-orange-200 text-orange-900 p-8 rounded-xl shadow-lg">
  //               <FaHospital className="text-5xl mx-auto text-orange-600 mb-4" />
  //               <h3 className="text-xl font-semibold mb-2">Referred Back</h3>
  //               {loading ? (
  //                 <div className="flex justify-center py-2">
  //                   <FaSpinner className="animate-spin text-2xl text-orange-600" />
  //                 </div>
  //               ) : (
  //                 <p className="text-4xl font-bold">{dashboardStats.referredBack}</p>
  //               )}
  //             </Link>
  //           </div>
  //         </div>
  //       ) : (
  //         <p className="text-center text-red-500">Access Denied. Please log in as a teacher.</p>
  //       )}
  //     </div>
  //   </div>
  // );
return (
    <div className="flex flex-col mt-32">
      {/* Main Card */}
      <div className="w-[90%] mx-auto bg-white p-6 shadow-2xl backdrop-blur-lg border border-gray-300 rounded-xl">
        
        {user && user.role === "teacher" ? (
          <div className="text-center">
            {/* Profile Section */}
            <div className="flex flex-col items-center mb-6">
              <div className="bg-blue-600 text-white p-3 rounded-full mb-4">
                <FaUserCircle className="text-7xl drop-shadow-md" />
              </div>
              <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-lg shadow-md">
                <h1 className="text-3xl font-bold">
                  Welcome, {user.name || user.username}
                </h1>
                <p className="text-lg mt-1">
                  {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
                </p>
              </div>
            </div>

            {/* Statistics Section */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
              <Link to="/teacher-dashboard/teacher-pending-report" className="stat-card bg-purple-50 border border-purple-300 text-purple-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-purple-100 transition block">
                <FaClipboardList className="text-4xl mx-auto text-purple-600 mb-2" />
                <h3 className="text-lg font-semibold">Pending Approval</h3>
                {loading ? (
                  <div className="flex justify-center py-2">
                    <FaSpinner className="animate-spin text-2xl text-purple-600" />
                  </div>
                ) : (
                  <p className="text-3xl font-bold">{dashboardStats.pendingApproval}</p>
                )}
              </Link>
  
              <Link to="/teacher-dashboard/teacher-approved-report" className="stat-card bg-green-50 border border-green-300 text-green-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-green-100 transition block">
                <FaExclamationTriangle className="text-4xl mx-auto text-green-600 mb-2" />
                <h3 className="text-lg font-semibold">Approved Assignments</h3>
                {loading ? (
                  <div className="flex justify-center py-2">
                    <FaSpinner className="animate-spin text-2xl text-green-600" />
                  </div>
                ) : (
                  <p className="text-3xl font-bold">{dashboardStats.approvedAssignments}</p>
                )}
              </Link>
  
              <Link to="/teacher-dashboard/teacher-rejected-report" className="stat-card bg-orange-50 border border-orange-300 text-orange-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-orange-100 transition block">
                <FaCheckCircle className="text-4xl mx-auto text-orange-600 mb-2" />
                <h3 className="text-lg font-semibold">Referred Back</h3>
                {loading ? (
                  <div className="flex justify-center py-2">
                    <FaSpinner className="animate-spin text-2xl text-orange-600" />
                  </div>
                ) : (
                  <p className="text-3xl font-bold">{dashboardStats.referredBack}</p>
                )}
              </Link>
            </div>
          </div>
        ) : (
          <p className="text-center text-red-500">Access Denied. Please log in as a teacher.</p>
        )}
      </div>
    </div>
  );


};

export default TeacherHome;



















// import React, { useState, useEffect } from "react";
// import {
//   FaUserCircle,
//   FaClipboardList,
//   FaExclamationTriangle,
//   FaCheckCircle,
//   FaSpinner,
// } from "react-icons/fa";
// import { useUser } from '../UserContext';

// const TeacherHome = () => {
//   const { user } = useUser();
//   const [dashboardStats, setDashboardStats] = useState({
//     pendingApproval: 0,
//     approvedAssignments: 0,
//     referredBack: 0,
//   });
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     fetchPendingReports();
//   }, []); 

//   const fetchPendingReports = async () => {
//     setLoading(true);
//     try {
//       const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost:5001').trim();
//       const response = await fetch(`${apiUrl}/api/report-stats`);
      
//       if (!response.ok) {
//         throw new Error('Failed to fetch PDF reports');
//       }
      
//       const data = await response.json();
      
//       const pendingReports = data.filter(report => report.status === 'pending');
//       const approvedReports = data.filter(report => report.status === 'approved');
//       const rejectedReports = data.filter(report => report.status === 'rejected');
      
//       setDashboardStats(prev => ({
//         ...prev,
//         pendingApproval: pendingReports.length,
//         approvedAssignments: approvedReports.length,
//         referredBack: rejectedReports.length
//       }));
//     } catch (err) {
//       console.error('Error fetching reports:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     console.log(dashboardStats);
//   }, [dashboardStats]);

//   return (
//     <div className="flex flex-col mt-32">
//       {/* Main Card */}
//       <div className="w-[90%] mx-auto bg-white p-6 shadow-2xl backdrop-blur-lg border border-gray-300 rounded-xl">
        
//         {user && user.role === "teacher" ? (
//           <div className="text-center">
//             {/* Profile Section */}
//             <div className="flex flex-col items-center mb-6">
//               <div className="bg-blue-600 text-white p-3 rounded-full mb-4">
//                 <FaUserCircle className="text-7xl drop-shadow-md" />
//               </div>
//               <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-lg shadow-md">
//                 <h1 className="text-3xl font-bold">
//                   Welcome, {user.name || user.username}
//                 </h1>
//                 <p className="text-lg mt-1">
//                   {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
//                 </p>
//               </div>
//             </div>

//             {/* Statistics Section */}
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
//               <div className="stat-card bg-purple-50 border border-purple-300 text-purple-900 p-6 rounded-lg shadow-lg">
//                 <FaClipboardList className="text-4xl mx-auto text-purple-600 mb-2" />
//                 <h3 className="text-lg font-semibold">Pending Approval</h3>
//                 {loading ? (
//                   <div className="flex justify-center py-2">
//                     <FaSpinner className="animate-spin text-2xl text-purple-600" />
//                   </div>
//                 ) : (
//                   <p className="text-3xl font-bold">{dashboardStats.pendingApproval}</p>
//                 )}
//               </div>
  
//               <div className="stat-card bg-green-50 border border-green-300 text-green-900 p-6 rounded-lg shadow-lg">
//                 <FaExclamationTriangle className="text-4xl mx-auto text-green-600 mb-2" />
//                 <h3 className="text-lg font-semibold">Approved Assignments</h3>
//                 <p className="text-3xl font-bold">{dashboardStats.approvedAssignments}</p>
//               </div>
  
//               <div className="stat-card bg-orange-50 border border-orange-300 text-orange-900 p-6 rounded-lg shadow-lg">
//                 <FaCheckCircle className="text-4xl mx-auto text-orange-600 mb-2" />
//                 <h3 className="text-lg font-semibold">Referred Back</h3>
//                 <p className="text-3xl font-bold">{dashboardStats.referredBack}</p>
//               </div>
//             </div>
//           </div>
//         ) : (
//           <p className="text-center text-red-500">Access Denied. Please log in as a teacher.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default TeacherHome;
